/*
* Import common js to use common function in this javascript file
*/
import { deleteConfirmationAlert, commonClockTimepicker, timePickerMask } from "./common";

/*-----------------------------------------------------*/
// Closing time
/*-----------------------------------------------------*/

// Closing time - Add closing time block
window.$(".closingTimeForm .plus-icon").on('click', function(e){
    e.preventDefault();
    Promise.resolve(1).then(function resolve() {
        timePickerMask();
        commonClockTimepicker();
    });
    var day = window.$(this).parents('td').attr('key');
    var meal = window.$(this).parents('td').attr('meal');
    window.$('.closingTime').find('.block-container').find('.day').val(day);
    window.$('.closingTime').find('.block-container').find('.meal').val(meal);
    var block = window.$('.closingTime').find('.block-container').html();
    window.$(this).siblings('.time-container').append(block);
});

// Closing time - Remove the time block
window.$(document).on('click', ".closingTimeForm .delete-icon ", function(e) {
    var currentObj = window.$(this);

    // If confirmation true, do action for delete
    if(currentObj.closest('.block').find('.id').val() == ""){
        currentObj.closest('.block').remove();
        return false
    }
    // Call method for delete confirmation
    var promise = deleteConfirmationAlert();
    promise.then(function(result) {
        window.axios({
            method: "delete",
            url: window.$(".closingTimeForm").attr('action') + '/' + currentObj.closest('.block').find('.id').val(),
        }).then(function (response) {
            window.toastr.success(response.data.message, response.statusText);

            currentObj.closest('.block').remove();
        }).catch(function (error) {
            window.toastr.error(error.response.data.message, error.response.data.statusText);

        });
    }).catch(function(err) {
        return false;
    });


});

// closing - Cancel the new time block
window.$(document).on('click', ".closingTimeForm .cancel-icon ", function(e) {
    var currentObj = window.$(this);
    // If confirmation true, do action for delete
    if(currentObj.closest('.block').find('.id').val() == ""){
        currentObj.closest('.block').remove();
        return false
    }
    window.$(this).closest('.block').find(".delete-icon").removeClass('d-none');
    window.$(this).closest('.block').find(".cancel-icon").addClass('d-none');
    window.$(this).closest('.block').find(".fa-check-circle").addClass('d-none');
    window.$(this).closest('.block').find(".fa-pen").removeClass('d-none');
    window.$(this).closest('.block').find('input').removeClass('d-none');
    window.$(this).closest('.block').find('.time span').removeClass('d-none');
    window.$(this).closest('.block').find('.col').addClass('d-none');
    window.$(this).closest('.block').find('input[type="number"]').attr('disabled', 'disabled');
    window.$(this).closest('.block').addClass('disabled');

 });
// Closing time - Edit the time block
window.$(document).on('click', ".closingTimeForm .fa-pen ", function(e) {
    window.$(this).closest('.block').find(".delete-icon").addClass('d-none');
    window.$(this).closest('.block').find(".cancel-icon").removeClass('d-none');
    window.$(this).closest('.block').find(".fa-check-circle").removeClass('d-none');
    window.$(this).addClass('d-none');
    window.$(this).closest('.block').find('span').addClass('d-none');
    window.$(this).closest('.block').removeClass('disabled');
    window.$(this).closest('.block').find('input').removeClass('d-none');
    window.$(this).closest('.block').find('.time span').addClass('d-none');
    window.$(this).closest('.block').find('.col').removeClass('d-none');
    window.$(this).closest('.block').find('input[type="number"]').removeAttr('disabled');
    window.$(this).closest('.block').removeClass('disabled');
});
// Closing time - Remove the time block
window.$(document).on('click', ".closingTimeForm .save-icon ", function(e) {
    var isValid = true;
    window.$(this).closest('.block').find('input.time').each(function(){
        if(! validationDisplayWithoutMessage(window.$(this))) {
            isValid = false;
            return false;
        } else {
            window.$(this).removeClass('error');
        }
    });
    if(isValid == true){
        var currentObj = window.$(this);
        window.axios({
            method: "post",
            url: window.$(".closingTimeForm").attr('action'),
            data: window.$(this).closest('.block').find('input').serialize(),
        }).then(function (response) {
            window.toastr.success(response.data.message, response.statusText);
            currentObj.addClass('d-none');
            currentObj.closest('.block').find(".id").val(response.data.data.id);
            currentObj.closest('.block').find(".fa-pen").removeClass('d-none');
            var end_time = currentObj.closest('.block').find('input[name="end_time"]').val();
            var start_time = currentObj.closest('.block').find('input[name="start_time"]').val();
            currentObj.closest('.block').find('.time span').text(start_time + ' - '+end_time);
            currentObj.closest('.block').find('.col').addClass('d-none');
            currentObj.closest('.block').find('input[type="number"]').attr('disabled','disabled');
            currentObj.closest('.block').addClass('disabled');
            currentObj.closest('.block').find('input.cover').removeClass('error');
            currentObj.closest('.block').find(".delete-icon").removeClass('d-none');
            currentObj.closest('.block').find(".cancel-icon").addClass('d-none');

        }).catch(function (error) {
            if(typeof error.response !== 'undefined') {
                if(error.response.status == 400){
                    window.$.each( error.response.data, function( key, value ) {
                        currentObj.closest('.block').find('input.'+key).addClass('error');
                        window.toastr.error(value, error.response.data.statusText);
                    });
                    return false;
                }
                window.toastr.error(error.response.data.message, error.response.data.statusText);
            }

        });
    }
});


function validationDisplayWithoutMessage(currentObject){
    currentObject.removeClass('error');
    if(currentObject.val() == "" || ! validateHhMm(currentObject.val())) {
        currentObject.addClass('error');
        window.toastr.error(window.$(".closingTimeForm").attr('invalid-msg'));
        return false;
    }
    return true;
}


// Validate hours and minute format
function validateHhMm(time) {
    return  /^([0-1]?[0-9]|2[0-3]):([0-5][0-9])(:[0-5][0-9])?$/.test(time);
}
